export default function getUrlParam(param) {
  let searchParams = new URLSearchParams(window.location.search);
  return searchParams.get(param);
}
